import React, { useState } from 'react';
// import icons
import { IoMdClose } from 'react-icons/io';
import { CgMenuRight } from 'react-icons/cg';
// import link
import { Link } from 'react-router-dom';
// import motion
import { motion } from 'framer-motion';
import {ImInstagram} from 'react-icons/im';
import { ImLinkedin } from 'react-icons/im';

// menu variants
const menuVariants = {
  hidden: {
    x: '100%',
  },
  show: {
    x: 0,
    transition: {
      ease: [0.6, 0.01, -0.05, 0.9],
    },
  },
};

const MobileNav = () => {
  const [openMenu, setOpenMenu] = useState(false);
  return (
    <nav className='text-primary xl:hidden'>
      {/* nav open button */}
      <div
        onClick={() => setOpenMenu(true)}
        className='text-3xl cursor-pointer'
      >
        <CgMenuRight className='text-white' />
      </div>
      {/* menu */}
      <motion.div
        variants={menuVariants}
        initial='hidden'
        animate={openMenu ? 'show' : ''}
        className='bg-white shadow-2xl w-full absolute top-0 right-0 max-w-xs h-screen z-20'
      >
        {/* icon */}
        <div
          onClick={() => setOpenMenu(false)}
          className='text-4xl absolute z-30 left-4 top-14 cursor-pointer'
        >
          <IoMdClose />
        </div>
        {/* menu list */}
        <ul className=' flex flex-col justify-center h-3/4 items-center gap-y-4 text-primary font-primary   font-bold h4 lg:text-3xl'>
          <li className='hover:text-gray-800'>
            <Link to='/open-calls'>Open Calls</Link>
          </li>
          <li className='hover:text-gray-800'>
            <Link to='/about'>Board</Link>
          </li>
          <li className='hover:text-gray-800'>
            <Link to='/projects'>Projects</Link>
          </li>
           <li className='hover:text-gray-800'>
            <Link to='/album'>Gallery</Link>
          </li>
          <li className='hover:text-gray-800'>
            <Link to='/contact'>Join Us</Link>
          </li>
          <li className='flex space-x-4'>
          <a className='hover:text-gray-800' href='https://www.instagram.com/we_collectiveart/' target='_blank' rel="noreferrer">
            <ImInstagram />
          </a>
          </li>
        </ul>
      </motion.div>
    </nav>
  );
};

export default MobileNav;
